import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({
  name: 'uniq'
})
export class UniqPipe implements PipeTransform {

  transform(array, args) {
    return _.uniqBy(array, args)
  }

}
